export const authRoutes = [
  {
    path: "login",
    name: "login",
    meta: { transitionName: "slide" },
    component: () =>
      import(/* webpackChunkName: "login" */ "../../views/auth/login/index"),
    children: [
      {
        path: "/",
        name: "loginForm",
        meta: { transitionName: "slide" },
        component: () =>
          import(
            /* webpackChunkName: "google-auth" */ "../../views/auth/login/login/index"
          )
      },
      {
        path: "google-auth",
        name: "googleAuth",
        meta: { transitionName: "slide" },
        component: () =>
          import(
            /* webpackChunkName: "google-auth" */ "../../views/auth/google-auth/index"
          ),
        async beforeEnter(to, from, next) {
          let isAuth = await localStorage.getItem("google2faToken");
          if (isAuth) {
            next();
          } else {
            next({
              path: "/auth/login" // back to safety route //
              // query: { redirectFrom: to.fullPath }
            });
          }
        }
      },
      {
        path: "otp-auth",
        name: "otpAuth",
        meta: { transitionName: "slide" },
        component: () =>
          import(
            /* webpackChunkName: "otp-auth" */ "../../views/auth/otp-auth/index"
          ),
        async beforeEnter(to, from, next) {
          let isAuth = await localStorage.getItem("otpToken");
          if (isAuth) {
            next();
          } else {
            next({
              path: "/auth/login" // back to safety route //
              // query: { redirectFrom: to.fullPath }
            });
          }
        }
      },
      {
        path: "email-auth",
        name: "emailAuth",
        meta: { transitionName: "slide" },
        component: () =>
          import(
            /* webpackChunkName: "email-auth" */ "../../views/auth/email-auth/index"
          ),
        async beforeEnter(to, from, next) {
          let isAuth = await localStorage.getItem("emailOtpToken");
          if (isAuth) {
            next();
          } else {
            next({
              path: "/auth/login" // back to safety route //
              // query: { redirectFrom: to.fullPath }
            });
          }
        }
      },
      {
        path: "password-recovery",
        name: "passwordRecovery",
        meta: { transitionName: "slide" },
        component: () =>
          import(
            /* webpackChunkName: "password-recovery" */ "../../views/auth/password-recovery/index"
          )
      },
      {
        path: "password-recovery-otp",
        name: "passwordRecoveryOtp",
        meta: { transitionName: "slide" },
        component: () =>
          import(
            /* webpackChunkName: "password-recovery" */ "../../views/auth/password-recovery-otp/index"
          ),
        async beforeEnter(to, from, next) {
          let isAuth = await localStorage.getItem("otpToken");
          if (isAuth) {
            next();
          } else {
            next({
              path: "/auth/login" // back to safety route //
              // query: { redirectFrom: to.fullPath }
            });
          }
        }
      },
      {
        path: "password-reset",
        name: "passwordReset",
        meta: { transitionName: "slide" },
        component: () =>
          import(
            /* webpackChunkName: "password-recovery" */ "../../views/auth/password-reset/index"
          ),
        async beforeEnter(to, from, next) {
          let isAuth = await localStorage.getItem("otpToken");
          if (isAuth) {
            next();
          } else {
            next({
              path: "/auth/login" // back to safety route //
              // query: { redirectFrom: to.fullPath }
            });
          }
        }
      },
      {
        path: "disable-GA",
        name: "disableGA",
        meta: { transitionName: "slide" },
        component: () =>
          import(
            /* webpackChunkName: "password-recovery" */ "../../views/auth/disable-GA/index.vue"
          )
      }
    ]
  },
  {
    path: "register",
    name: "register",
    meta: { transitionName: "slide" },
    component: () =>
      import(
        /* webpackChunkName: "register" */ "../../views/auth/register/index"
      ),
    children: [
      {
        path: "/",
        name: "registerForm",
        meta: { transitionName: "slide" },
        component: () =>
          import(
            /* webpackChunkName: "google-auth" */ "../../views/auth/register/register/index"
          )
      },
      {
        path: "register-verification",
        name: "registerVerification",
        meta: { transitionName: "slide" },
        component: () =>
          import(
            /* webpackChunkName: "registerVerification" */ "../../views/auth/register-verification/index"
          ),
        async beforeEnter(to, from, next) {
          let isAuth = await localStorage.getItem("otpToken");
          if (isAuth) {
            next();
          } else {
            next({
              path: "/auth/register" // back to safety route //
              // query: { redirectFrom: to.fullPath }
            });
          }
        }
      },
      {
        path: "go-for-signin",
        name: "goToLogin",
        meta: { transitionName: "slide" },
        component: () =>
          import(
            /* webpackChunkName: "google-auth" */ "../../views/auth/goToLogin/index"
          )
      }
    ]
  },
  {
    name: "password-changed",
    path: "password-changed",
    component: () =>
      import("../../views/auth/password-changed/PasswordChanged.vue")
  }
];
